export default __webpack_public_path__ + "static/media/removeDoubles.888fc905.png";